var map = {
	"./decidim/avatar-multiuser.png": 77019,
	"./decidim/brands/facebook.svg": 59667,
	"./decidim/brands/google.svg": 69482,
	"./decidim/brands/twitter-x.svg": 46331,
	"./decidim/cc-badge.png": 91977,
	"./decidim/decidim-logo.svg": 65897,
	"./decidim/default-avatar.svg": 99737,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 95999,
	"./decidim/icons.svg": 9272,
	"./decidim/pattern.png": 74635,
	"./decidim/placeholder-card-g.svg": 26008,
	"./decidim/placeholder-card-l.svg": 41235,
	"./decidim/placeholder.jpg": 73082,
	"./decidim/remixicon.symbol.svg": 98496,
	"./decidim/vendor/social-share-button/douban.svg": 93971,
	"./decidim/vendor/social-share-button/email.svg": 77740,
	"./decidim/vendor/social-share-button/facebook.svg": 80120,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 74620,
	"./decidim/vendor/social-share-button/hacker_news.svg": 37920,
	"./decidim/vendor/social-share-button/linkedin.svg": 70122,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 93299,
	"./decidim/vendor/social-share-button/pinterest.svg": 61018,
	"./decidim/vendor/social-share-button/reddit.svg": 76368,
	"./decidim/vendor/social-share-button/telegram.svg": 64885,
	"./decidim/vendor/social-share-button/tumblr.svg": 52722,
	"./decidim/vendor/social-share-button/twitter.svg": 36489,
	"./decidim/vendor/social-share-button/vkontakte.svg": 44867,
	"./decidim/vendor/social-share-button/wechat.svg": 97870,
	"./decidim/vendor/social-share-button/whatsapp.svg": 50822,
	"./decidim/vendor/social-share-button/x.svg": 5303,
	"./decidim/vendor/social-share-button/xing.svg": 97876
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27922;